import { TimeDateHelper } from "app/helpers/timeDateHelper";
import store from "app/store/store";
import { SessionType } from "app/types/userType";
import BetDrawerLogic from "../logic/betDrawerLogic";
import CompetitionLogic from "../logic/competitionLogic";
import EventLogic from "../logic/eventLogic";
import FinanceLogic from "../logic/financeLogic";
import NavigationLogic from "../logic/navigationLogic";
import OddsLogic from "../logic/oddsLogic";
import SummaryLogic from "../logic/summaryLogic";
import UserLogic from "../logic/userLogic";

export class WsHelper {
  static onMessage(data) {
    // console.log("data: ", data);
    //
    switch (data.type) {
      case "account_stats":
        SummaryLogic.updateSummary(data.data);
        break;

      case "navigation":
        NavigationLogic.updateNavigationTree(data.data);
        break;

      case "navigation_live":
        break;

      case "events_summary":
        CompetitionLogic.updateNumberLiveEvents(data.data);
        break;

      case "events":
        CompetitionLogic.updateCompetitionEvent(data.data);
        BetDrawerLogic.updateBetSlipsFromClosedEvents(data.data);
        break;

      case "markets":
        CompetitionLogic.updateMarket(data.data);
        EventLogic.updateMarket(data.data);
        break;

      case "runners":
        CompetitionLogic.updateRunner(data.data);
        BetDrawerLogic.updateBetSlipsFromWebSocketRunner(data.data);
        break;

      case "prices":
        data.data.forEach(priceUpdate => {
          priceUpdate.isWebsocketPrice = true;
        });
        OddsLogic.updateOdds(data.data);

        break;

      case "balance":
        FinanceLogic.updateFinance(data.data);
        break;

      case "bets":
        BetDrawerLogic.updateBetSlipFromBet(data.data[0]);
        if (data.data[0].affectedRunnerProfitAndLoss) {
          CompetitionLogic.updateRunnerPNL(
            data.data[0].affectedRunnerProfitAndLoss
          );
        }
        break;

      case "session":
        UserLogic.sessionUpdate(data.data);
        break;

      case "positions":
        break;

      case "incidents":
        CompetitionLogic.updateEventIncident(data.data);
        BetDrawerLogic.updateEventIncident(data.data);
        EventLogic.updateEventIncident(data.data);
        break;

      default:
        break;
    }
  }

  static checkWsStatus(
    socket: WebSocket,
    numberOfSocketReconnections: number,
    socketIsClosingMessageSent: boolean
  ) {
    // Check what state the ws connection is in
    // To help with debugging if there are ws issues
    switch (socket.readyState) {
      case 0:
        // 0 	CONNECTING 	Socket has been created. The connection is not yet open.
        console.log("Socket is connecting: ", socket.readyState);
        break;
      case 1:
        // 1 	OPEN 	The connection is open and ready to communicate.
        break;
      case 2:
        // 2 	CLOSING 	The connection is in the process of closing.
        // Sometimes CLOSING happens before CLOSE
        // Sometimes CLOSE happens without CLOSING
        const timeClose =
          TimeDateHelper.getUTCFormattedDateTime("HH:mm:ss SSS");
        const session: SessionType = store.getState().sessionModel.session;
        const wsCloseMessage = `WS Socket is closing: User : ${session.username} IPAddress: ${session.ipAddress} Time: ${timeClose} NumberOfSocketReconnections: ${numberOfSocketReconnections}`;
        if (!socketIsClosingMessageSent) {
          console.log("Socket is closing: ", wsCloseMessage);
        }
        socketIsClosingMessageSent = true;
        break;
      case 3:
        console.log("Socket is closed: ", socket.readyState);
        // 3 	CLOSED 	The connection is closed or couldn't be opened.
        // Handled in the CLOSE listener
        break;
      default:
        break;
    }
    return socketIsClosingMessageSent;
  }
}
